const Op = require("./Op.js");
const reg = require("./regExp.js");

// 查询关键字
const validateQueryKeywords = new Set([
  "where",
  "attributes",
  "order",
  "limit",
  "offset"
]);

class Model {
  constructor(values = {}, options = {}) {
    this.sequelize = null;
    this.attributes = {};
  }

  /**
   * 初始化模型
   * @param {object} attributes 属性对象集合（对应字段名）
   * @param {object} options 附加设置
   * attributes: {
   *   name: {
   *     types:
   *   }
   * }
   */
  init(attributes, options = {}) {
    this.attributes = attributes;

    let { sequelize = null } = options;

    if (!sequelize) {
      throw new Error(
        "ViewModel Sequlize Model：model没有找到与之相关联的sequelize"
      );
    }

    this.sequelize = sequelize;

    return this;
  }

  /**
   * 数据格式化
   * @param {object} source 原始数据
   * @param {object} enums 枚举
   */
  parse(source, enums) {
    let target = {};
    let enumItem = [];
    Object.keys(source).forEach(key => {
      // 判断是否存在枚举
      enumItem = enums && key in enums ? enums[key] : [];

      if (key in this.attributes) {
        let value = this.attributes[key]["parse"]
          ? this.attributes[key].parse(source[key], target, enumItem)
          : // ? this.attributes[key].parse(source[key], target)
            source[key];

        target[key] = value;
      }
    });

    return target;
  }

  /**
   * get result by multiple params
   * @param {any} options
   * @param {object} options.where 查询字段
   * @param {number} options.limit 每页展示的条数
   * @param {number} options.offset 需要跳过的条数
   * @param {Array} options.order 排序
   * @param {Array} source 原始数据
   */
  findAll(options, source) {
    if (!options) {
      return;
    }

    let { where = {}, limit = null, offset = null, order = [] } = options;

    // 根据where获取满足条件的数据
    let result = source.filter(item => {
      let res = true;

      let params = Object.keys(where);

      for (let i = 0; i < params.length; i++) {
        let param = params[i];
        let valid = this.validateEachParam(where[param], item[param]);
        if (!valid) {
          res = false;
          break;
        }
      }

      return res;
    });

    // 检索结果总条数
    let count = result.length;

    // 排序
    let orderResult =
      order.length > 0 ? this.getOrderData(order, result) : result;

    // 分页
    let limitResult = this.getLimitData(limit, offset, orderResult);

    return {
      raw: limitResult.raw
    };

    // 字段验证警告
    // this.warnOnInvalidOptions(options, Object.keys(this.rawAttributes));
  }

  validateEachParam(ops, sourceVal) {
    let standard = Object.getOwnPropertySymbols(ops);

    let valid = true;

    standard.forEach(op => {
      let targetVal = ops[op];
      let opValid = reg[op](targetVal, sourceVal);

      valid = valid && opValid;
    });

    return valid;
  }

  /**
   * 获取翻页数据
   * @param {*} limit 每页展示的条数
   * @param {*} offset 需要跳过的条数
   * @param {*} list 原始数据
   */
  getLimitData(limit = null, offset = 0, list = []) {
    let result = [];

    if (limit !== null && offset !== null) {
      if (limit < 0 || offset < 0) {
        console.warn("viewmodel: limit或offset不能为负数");
      } else {
        result = list.slice(offset, offset + limit);
      }
    }

    return {
      raw: result
    };
  }

  getOrderData(order = [], list = []) {
    let result = [];
    let counter = 0;
    let listLen = list.length;

    let [param, keyword] = order[0];

    /**
     * V1.0 只支持单个属性排序
     */
    result = list.sort((row1, row2) => {
      let val1 = row1[param];
      let val2 = row2[param];

      if (keyword === "DESC") {
        if (val1 > val2) {
          return -1;
        } else {
          return 1;
        }
      } else {
        if (val1 < val2) {
          return -1;
        } else {
          return 1;
        }
      }
    });

    return result;

    // let compare = () => {
    //   if (counter < listLen - 1) {
    //     let row1 = list[counter];
    //     let row2 = list[counter + 1];

    //     for (let i = 0; i < order.length; i++) {
    //       let [param, rev] = order[i];
    //       let val1 = row1[param];
    //       let val2 = row2[param];

    //       if (rev === "DESC") {
    //         if (val2 > val1) {
    //           result[counter] = row2;
    //           break;
    //         } else if (val2 < val1) {
    //           result[counter] = row1;
    //           break;
    //         }
    //       } else {
    //         // todo
    //       }
    //     }

    //     counter += 1;
    //     compare();
    //   } else if (counter === listLen - 1) {

    //   }
    // }

    // compare(0)

    // console.log("最终结果：");
    // console.log(result);

    let ite = () => {
      if (counter < order.length) {
        result = list.sort((row1, row2) => {
          let param = order[counter][0];
          let keyword = order[counter][1];
          let val1 = row1[param];
          let val2 = row2[param];

          if (keyword === "DESC") {
            // 降序
            if (val1 > val2) {
              return -1;
            } else if (val1 < val2) {
              return 1;
            } else {
            }
          } else {
            // 升序
            if (val1 < val2) {
              return -1;
            } else if (val1 >= val2) {
              return 1;
            }
          }
        });
        counter += 1;
        ite(counter);
      }
    };

    // ite(0);

    // console.log(result);

    // let test = (item1, item2) => {
    //   return new Promise(async (resolve) => {
    //     console.log("计数器：" + counter);
    //     if (counter < order.length) {
    //       let param = order[counter][0];
    //       let keyword = order[counter][1];
    //       let val1 = item1[param];
    //       let val2 = item2[param];

    //       console.log("=====");
    //       console.log(param);
    //       console.log(keyword);
    //       console.log(val1);
    //       console.log(val2);

    //       if (keyword === "DESC") {
    //         // 降序
    //         if (val1 > val2) {
    //           console.log("-1");
    //           // return -1;
    //           res = -1;
    //           // console.log(res);
    //           // return -1;
    //           resolve(-1);
    //         } else if (val1 < val2) {
    //           // if (counter > 0) {
    //           //   console.log("in");
    //           // }
    //           // console.log(1);
    //           // res = 1;
    //           // console.log(res);
    //           // return 1;
    //           resolve(1);
    //         } else {
    //           console.log("eq");
    //           // console.log(res);
    //           // 两者相等，进行下一个规则
    //           counter += 1;
    //           let b = await iterateq(item1, item2);
    //           console.log("eq 计算：" + b);
    //           return b;
    //         }
    //       }
    //       // else {
    //       //   console.log("暂时魏永");
    //       //   // 升序
    //       //   if (val1 < val2) {
    //       //     console.log(1);
    //       //     return -1;
    //       //   } else if (val1 > val2) {
    //       //     return 1;
    //       //   } else {
    //       //     console.log("eq```");
    //       //     // 两者相等，进行下一个规则
    //       //     counter += 1;
    //       //     iterateq(item1, item2)
    //       //   }
    //       // }
    //     } else {
    //       console.log("超出：" + res);
    //     }
    //   })
    // }

    // const iterateq = async (item1, item2) => {
    //   // let res = null;

    //   // let a = await test(item1, item2).then();

    //   // console.log("异步：" + a);

    //   // return a;

    //   /**
    //    * 测试
    //    */
    //   let a = await testAsync().then();
    //   console.log(a);
    //   return a;

    //   // console.log("运算结果：" + res);

    //   // return res;
    // }

    // let testAsync = () => {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve(1);
    //     }, 2000)
    //   });
    // }

    // result = list.sort(async (item1, item2) => {
    //   // let res = null;
    //   // let res = await iterateq(item1, item2);
    //   // console.log("1111111");
    //   // // console.log(res);
    //   // // console.log(res.then().then());
    //   // console.log("外部循环：" + res);

    //   // return res;

    //   /**
    //    * 测试
    //    */
    //   // console.log("遍历的对象：");
    //   // console.log(item1);
    //   // let a = await testAsync();
    //   // console.log("异步结果：" + a);

    //   return await testAsync();
    //   // console.log(a);
    //   // return a;
    // });

    // let aaa = 1;
    // let test1 = Promise((resolve) => {
    //   if (aaa < 3) {
    //     aaa += 1;
    //     setTimeout(() => {

    //     }, 2000);
    //   } else {

    //   }

    // })

    // console.log(result);
  }

  /**
   *
   * @param {*} options
   * @param {*} validColumnNames
   */
  warnOnInvalidOptions(options, validColumnNames) {
    // 非法属性集合
    const hasInvalidKey = Object.keys(options).filter(
      k => !validateQueryKeywords.has(k)
    );
    // 模型非法字段集合
    // todo
  }
}

export default Model;
